import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Radio from "@/pages/Radio";
import Roster from "@/pages/Roster";
import ArtistMessages from "@/pages/ArtistMessages";
import Submissions from "@/pages/Submissions";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";

function AppRoutes() {
  const location = useLocation();
  // Process OAuth return synchronously (URL fragment) before anything else
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/radio" element={<Radio />} />
        <Route path="/roster" element={<Roster />} />
        <Route path="/roster/messages" element={<ArtistMessages />} />
        <Route path="/submissions" element={<Submissions />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            border: "1px solid rgba(139,0,0,0.6)",
            color: "#E0E0E0",
          },
        }}
      />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
